import React from 'react';
import { Box, Text, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const TeamActivityBreadcrumb = ({ title, fromWhere, currentPage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get current page from props or location state if available
  const pageToNavigate = currentPage || location.state?.currentPage || 1;
  
  // Define navigation paths and labels based on fromWhere
  const getNavigationConfig = () => {
    switch (fromWhere) {
      case 'blog':
        return {
          path: '/newsroom',
          label: 'Newsroom',
          color: 'blue.700'
        };
      case 'team-activity':
        return {
          path: '/team-activity',
          label: 'Team Activity',
          color: 'teal.700'
        };
      default:
        return {
          path: '/team-activity',
          label: 'Team Activity',
          color: 'teal.700'
        };
    }
  };

  const navigationConfig = getNavigationConfig();

  const handleNavigation = () => {
    if (fromWhere === 'blog') {
      // For blog, navigate back to newsroom with page state
      navigate(navigationConfig.path, {
        state: { initialPage: pageToNavigate }
      });
    } else {
      // For team activity, navigate normally
      navigate(navigationConfig.path);
    }
  };

  return (
    <Box mb={6} mt={2}>
      <Breadcrumb separator="/" fontSize="lg" color="gray.600">
        <BreadcrumbItem>
          <BreadcrumbLink 
            as="button" 
            onClick={handleNavigation} 
            color={navigationConfig.color}
          >
            <ArrowBackIcon mr={1} /> {navigationConfig.label}
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage>
          <Text as="span" fontWeight="semibold" color="#222">{title}</Text>
        </BreadcrumbItem>
      </Breadcrumb>
    </Box>
  );
};

export default TeamActivityBreadcrumb;
